// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"0326916a","365":"ff1b8ddf"}[chunkId] + ".chunk.js";
};